<template>
  <Layout>
    <!-- <banner/> -->
    <division :img="require('@/assets/images/gateway/icon-jj.png')" text="公司简介"/>
    <briefly/>
    <div class="idea">
      <div class="en">Company Development Philosophy</div>
      <div class="zn">稳健、高效、持续、创新、共享</div>
    </div>
    <division :img="require('@/assets/images/gateway/icon-lx.png')" text="联系方式"/>
    <div class="contact">
      <div class="text">
        <div>
          <img src="@/assets/images/gateway/icon-phs.png"/>
          <span>021-62380024（办公室），021-52198305（招商）</span>
        </div>
        <div>
          <img src="@/assets/images/gateway/icon-email.png"/>
          <span>xdsyzgs@163.com</span>
        </div>
        <div>
          <img src="@/assets/images/gateway/icon-ads.png"/>
          <span>上海市长宁区协和路1158号</span>
        </div>
      </div>
      <div class="map"></div>
    </div>
  </Layout>
</template>

<script>
// import Banner from '../components/banner.vue'
import Division from '../components/division.vue'
import Briefly from './briefly.vue'
import Layout from '../Layout'
export default {
  components: {
    // Banner,
    Division,
    Briefly,
    Layout
  }
}
</script>

<style lang="scss" scoped>
.idea {
  background: url('~@/assets/images/gateway/bg-ln.png');
  height: 2rem;
  padding: 0.6rem 10%;
  box-sizing: border-box;
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
  margin: 0.5rem 0;
  .en {
    color: #EFF5FF;
    font-size: 0.14rem;
    opacity: 0.8;
  }
  .zn {
    color: #FFFFFF;
    font-size: 0.3rem;
    font-family: HYLingXinJ;
    font-weight: bold;
  }
}
.contact {
  padding: 0 10%;
  .text {
    display: flex;
    background: #EFF4FD;
    font-size: 0.14rem;
    height: 0.5rem;
    align-items: center;
    justify-content: space-between;
    padding: 0 0.2rem;
    box-sizing: border-box;
    margin-bottom: 0.15rem;
    >div {
      display: flex;
      align-items: center;
      img {
        width: 0.18rem;
        margin-right: 0.1rem;
      }
    }
  }
  .map {
    height: 8rem;
    margin-bottom: 0.5rem;
    background: url('~@/assets/images/gateway/map.jpg');
    background-size: 100% 100%;
    background-position: center;
    background-repeat: no-repeat;
  }
}
</style>